var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {}, [_c('legend', [_vm._v(" Process Notified Lost Shipment ")]), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "card-body1"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("Lost By")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.listtype),
      expression: "listtype"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "listtype",
      "id": "listtype"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.listtype = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("--All--")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ServiceCenter"
    }
  }, [_vm._v("ServiceCenter")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "Linehaul"
    }
  }, [_vm._v("Linehaul")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Client")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "right": _vm.srLoader
    }
  }, [_c('b-input-group', [_c('basic-select', {
    class: {
      'form-control': true
    },
    attrs: {
      "options": _vm.clientList,
      "selected-option": _vm.clientItemObj,
      "name": "clientid",
      "placeholder": "Select client"
    },
    on: {
      "select": _vm.getclientsObj
    },
    model: {
      value: (_vm.clientid),
      callback: function($$v) {
        _vm.clientid = $$v
      },
      expression: "clientid"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Zone")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubzoneid),
      expression: "hubzoneid"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "hubzoneid",
      "id": "hubzoneid"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubzoneid = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.zone_obj.hubzoneid
    }
  }, [_vm._v(_vm._s(_vm.zone_obj.hubzonename))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Hub Name")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hubname),
      expression: "hubname"
    }],
    class: {
      'form-control': true
    },
    attrs: {
      "name": "hubname",
      "id": "hubname"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.hubname = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": _vm.defaultHhub.HubID
    }
  }, [_vm._v(_vm._s(_vm.defaultHhub.HubName))])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Amount")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    staticClass: "col-sm-5",
    class: {
      'form-control': true
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "amount",
      "id": "amount"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amount = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NetPayment"
    }
  }, [_vm._v("Net Payment")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OctroiMRP"
    }
  }, [_vm._v("Octroi MRP")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amountcomparator),
      expression: "amountcomparator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.amount != 0 ? 'required' : ''))),
      expression: "`${amount != 0 ? 'required' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('amountcomparator')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "amountcomparator",
      "id": "amountcomparator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.amountcomparator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ">"
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("=")])]), _vm._v(" "), _c('b-form-input', {
    staticClass: "col-sm-12",
    class: {
      'form-control': true,
      'error': _vm.errors.has('netpayment')
    },
    attrs: {
      "type": "text",
      "name": "netpayment",
      "formatter": _vm.format_number
    },
    model: {
      value: (_vm.netpayment),
      callback: function($$v) {
        _vm.netpayment = $$v
      },
      expression: "netpayment"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amountcomparator')),
      expression: "errors.has('amountcomparator')"
    }],
    staticClass: "text-danger"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('netpayment')),
      expression: "errors.has('netpayment')"
    }],
    staticClass: "text-danger"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Aging")]), _vm._v(" "), _c('b-input-group', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gapdays),
      expression: "gapdays"
    }],
    staticClass: "col-sm-6",
    class: {
      'form-control': true,
      'error': _vm.errors.has('gapdays')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "gapdays",
      "id": "gapdays"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gapdays = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ShipmentGapDays"
    }
  }, [_vm._v("Aging From Manifestation")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NotifyGapDays"
    }
  }, [_vm._v("Aging From Lost Notify")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gapdayscomparator),
      expression: "gapdayscomparator"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.gapdays != 0 ? 'required' : ''))),
      expression: "`${gapdays != 0 ? 'required' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('gapdayscomparator')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "name": "gapdayscomparator",
      "id": "gapdayscomparator"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.gapdayscomparator = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "selected",
      "value": ""
    }
  }, [_vm._v("-Select-")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ">"
    }
  }, [_vm._v(">")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "<"
    }
  }, [_vm._v("<")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "="
    }
  }, [_vm._v("=")])]), _vm._v(" "), _c('b-form-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (("" + (_vm.gapdays != '' ? 'required|numeric' : ''))),
      expression: "`${gapdays != '' ? 'required|numeric' : ''}`"
    }],
    staticClass: "col-sm-3",
    class: {
      'form-control': true,
      'error': _vm.errors.has('txtgapdays')
    },
    staticStyle: {
      "margin-right": "6px"
    },
    attrs: {
      "type": "text",
      "name": "txtgapdays"
    },
    nativeOn: {
      "keydown": function($event) {
        return _vm.onlyNumber.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.txtgapdays),
      callback: function($$v) {
        _vm.txtgapdays = $$v
      },
      expression: "txtgapdays"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('gapdayscomparator')),
      expression: "errors.has('gapdayscomparator')"
    }],
    staticClass: "text-danger"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('txtgapdays')),
      expression: "errors.has('txtgapdays')"
    }],
    staticClass: "text-danger"
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("AWB Numbers")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.awbnumbers),
      expression: "awbnumbers"
    }],
    ref: "textarea",
    class: {
      'form-control': true,
      'error': _vm.errors.has('awbnumbers')
    },
    attrs: {
      "rows": "2",
      "name": "awbnumbers",
      "id": "awbnumbers"
    },
    domProps: {
      "value": (_vm.awbnumbers)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.awbnumbers = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "textarea-style",
    staticStyle: {
      "display": "block",
      "color": "blue"
    }
  }, [_vm._v(" (Note: Use comma (,) for multiple AWB numbers)\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "top": "2em"
    }
  }, [_c('button', {
    staticClass: "btn btn-success btn-sm",
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search")]), _vm._v("    \n             "), _c('button', {
    staticClass: "btn btn-primary btn-sm",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.exportForm
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v(" Export")]), _vm._v("    \n            "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "type": "reset"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset")])])])])])])], 1), _vm._v(" "), _c('div', {}, [_c('legend', [_vm._v("Process Notified Lost Shipment List")]), _vm._v(" "), _c('div', {
    staticClass: "card-headerfrm",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "action": "",
      "method": "post",
      "data-vv-scope": "form-1"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.validateForm('form-1')
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v("Total Record: " + _vm._s(_vm.totalRecords) + " ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Total Selected : " + _vm._s(_vm.totalSelectedRecords) + " ")])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoading
    },
    on: {
      "update:active": function($event) {
        _vm.isLoading = $event
      }
    }
  }), _vm._v(" "), (_vm.errorMessage) ? _c('div', {
    staticClass: "alert alert-danger text-center",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "input-group table-area",
    staticStyle: {
      "overflow-x": "auto"
    }
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%",
      "margin-bottom": "20px"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [(_vm.isLostNewFeaturesisOnThisHub) ? _c('input', {
    key: _vm.form.shippingidchk.length,
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.isAllSelected
    },
    on: {
      "change": function($event) {
        return _vm.selectItems($event)
      }
    }
  }) : _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.checkbox),
      expression: "checkbox"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.checkbox) ? _vm._i(_vm.checkbox, null) > -1 : (_vm.checkbox)
    },
    on: {
      "click": function($event) {
        return _vm.selectItems($event)
      },
      "change": [function($event) {
        var $$a = _vm.checkbox,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checkbox = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.checkbox = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.checkbox = $$c
        }
      }, _vm.calculateselectedcount]
    }
  })]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.listRaiseDebitData), function(data, index) {
    return _c('tr', [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.form.shippingidchk),
        expression: "form.shippingidchk"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": data,
        "checked": Array.isArray(_vm.form.shippingidchk) ? _vm._i(_vm.form.shippingidchk, data) > -1 : (_vm.form.shippingidchk)
      },
      on: {
        "change": [function($event) {
          var $$a = _vm.form.shippingidchk,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = data,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.form, "shippingidchk", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.form, "shippingidchk", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.form, "shippingidchk", $$c)
          }
        }, function($event) {
          return _vm.calculateselectedcount($event, data)
        }]
      }
    })]), _vm._v(" "), _c('td', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.getShipmentLogData(data.ShippingID)
        }
      }
    }, [_vm._v(_vm._s(data.ShippingID))])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ClientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NetPayment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OctroiMRP))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NotifyStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Status))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentStatus))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CurrentHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.OriginHubName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.FinalDestinationName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.NotifyGapDays) + " " + _vm._s(data.NotifyGapDays > 1 ? '(days)' : '(day)'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ShipmentGapDays) + " " + _vm._s(data.ShipmentGapDays > 1 ? '(days)' : '(day)'))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))])])
  }), _vm._v(" "), (_vm.resultCount == 0) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "15",
      "align": "center"
    }
  }, [_vm._v("No record found")])]) : _vm._e()], 2)])])], 1), _vm._v(" "), _c('paginate', {
    ref: "paginate",
    attrs: {
      "page-count": _vm.pagecount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "size": "vlg"
    },
    on: {
      "ok": function($event) {
        _vm.shipmentlogmodal = false
      }
    },
    model: {
      value: (_vm.shipmentlogmodal),
      callback: function($$v) {
        _vm.shipmentlogmodal = $$v
      },
      expression: "shipmentlogmodal"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-card', [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', {
    staticClass: "mdltitle"
  }, [_vm._v("Shipment Log")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeShipmentLogModal
    }
  }, [_vm._v("x")])]), _vm._v(" "), _c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ShippingID")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("BagNo")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("ProcessLocation")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Process")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Comment")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedDate")])]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("CreatedBy")])])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.shipmentLogList), function(data, index) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(data.ShippingID))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.BagNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.ProcessLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Process))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.Comments))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedDate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(data.CreatedBy))])])
  }), 0)])])], 1)])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "text-align": "end"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary btn-sm",
    staticStyle: {
      "margin-left": "250px",
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "submit"
    }
  }, [_c('i', {
    staticClass: "fa fa-dot-circle-o"
  }), _vm._v("Raise Debit")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipping ID")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Client")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Net Payment")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Octroi MRP")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Notify Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Shipment Status")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Current Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Origin Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Destination Hub")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Aging From Lost Notify")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Aging From Manifestation")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    staticClass: "text-center tableheader"
  }, [_c('b', [_vm._v("Created By")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5357d106","hasScoped":true}!./src/views/components/LOST/RaiseDebit/RaiseDebit.component.html
// module id = 1084
// module chunks = 1